import { useMemo } from 'react';

const FormResponsesCount = ({items}) => {
  // Count unique questions 
    const uniqueQuestionsAnswered = useMemo(() => {
      if (!Array.isArray(items) || items.length === 0) return 0;

      const uniqueSet = new Set();

      for (const r of items) {
        uniqueSet.add(r.FieldID);
        
      }
  
      return uniqueSet.size;
    }, [items]);

    return <>{uniqueQuestionsAnswered}</>;
}

export default FormResponsesCount;
